import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBulkUpdateValue } from 'store/Contextualization/AssetDetail/actions';
import { selectBulkUpdateCustomAttribute, selectModalBulkUpdateValue, selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import get from 'lodash/get';
import { Dropdown } from 'Common/Components/Inputs';
import { parseOptions } from 'Screens/Contextualization/Manage/components/CustomAttributesModal/functions';
import { newDropdownStyle } from 'Common/styles/style';
import { Title, ChoiceWrapper } from 'Screens/Contextualization/Manage/components/ManageTable/components/BulkUpdateModal/styled';
import { CustomOption } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/CustomFieldsTab/components/ChoiceCustomField';
import { ThemeContext } from 'Context';

const ChoiceInput = () => {
  const dispatch = useDispatch();
  const customAttribute = useSelector(selectBulkUpdateCustomAttribute);
  const onChange = (opt) => dispatch(setBulkUpdateValue(opt.value));
  const fieldName = get(customAttribute, 'field_display_name', '');
  const options = get(customAttribute, 'field_metadata', '');
  const optionsArray = parseOptions(options);
  const parsedOptions = optionsArray.map((option) => ({ label: option, value: option }));
  parsedOptions.unshift({ label: '(Empty)', value: '(Empty)' });
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);
  const value = ((vulnsSelected.length > 1) || (bulkUpdateValue === null)) ? '' : { label: bulkUpdateValue, value: bulkUpdateValue };
  const { themeStyles } = useContext(ThemeContext);

  return (
    <ChoiceWrapper>
      <Title children={ fieldName } />
      <Dropdown
        defaultValue={ value }
        field="option_field"
        options={ parsedOptions }
        onChange={ onChange }
        placeholder="Choose Option"
        style={ newDropdownStyle(themeStyles) }
        components={ { Option: CustomOption } }
      />
    </ChoiceWrapper>
  );
};

export default ChoiceInput;
